import { useEffect, useState } from 'react';
import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';

interface DeleteExpenseRecordModalProps {
    recordLabel: string | null;
    isDeleting: boolean;
    onDismiss: () => void;
    onConfirmDelete: () => void;
}

export const DeleteExpenseRecordModal = ({
    recordLabel,
    isDeleting,
    onDismiss,
    onConfirmDelete,
}: DeleteExpenseRecordModalProps) => {
    const visible = recordLabel !== null;
    const [confirmReady, setConfirmReady] = useState(false);

    useEffect(() => {
        if (!visible) {
            setConfirmReady(false);
            return;
        }
        setConfirmReady(false);
        const timer = window.setTimeout(() => setConfirmReady(true), 400);
        return () => window.clearTimeout(timer);
    }, [visible, recordLabel]);

    return (
        <CustomModal
            onDismiss={onDismiss}
            visible={visible}
            header="Delete this expense?"
            footer={
                <div className="modal-footer-actions">
                    <Btn
                        variant="secondary-outlined"
                        buttonText="Cancel"
                        buttonDisabled={isDeleting}
                        buttonOnClick={onDismiss}
                    />
                    <Btn
                        variant="danger"
                        buttonText={isDeleting ? 'Deleting...' : 'Delete expense'}
                        buttonDisabled={isDeleting || !confirmReady}
                        buttonOnClick={onConfirmDelete}
                    />
                </div>
            }
        >
            <p>
                You are about to delete the expense for <strong>{recordLabel}</strong>. This cannot be undone.
            </p>
            <p>The equipment unit and expense categories stay. Only this cost record is removed.</p>
        </CustomModal>
    );
};
